export default {
  /* ================== mutations ============== */
  SET_SYNC_COURSE: 'SET_SYNC_COURSE',
  SET_BANNER_IMAGES: 'SET_BANNER_IMAGES',
  SET_GRADE_SUBJECT: 'SET_GRADE_SUBJECT',
  SET_DEFAULT_TERM: 'SET_DEFAULT_TERM',
  SET_HOME_COURSES: 'SET_HOME_COURSES',

  /* ================== actions ============== */
  GET_BANNER_IMAGES: 'GET_BANNER_IMAGES',
  GET_GRADE_SUBJECT: 'GET_GRADE_SUBJECT',
  GET_HOME_COURSES: 'GET_HOME_COURSES'
}



// WEBPACK FOOTER //
// ./src/views/IndexPage/store/types.js